/**
 * Created by Jie Gao on 2019-02-12.
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {StarStruckGameConfig} from "../StarStruckGameConfig";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";

export class Logo extends BaseView {

    private _logo:PIXI.Sprite;

    constructor() {
        super();
    }

    protected initAnimations():void {
        const logo:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("introLogo")[0]);
        logo.scale.set(0.6,0.6);
        logo.anchor.set(0.5, 1);
        StageManager.getLayer(StarStruckGameConfig.instance.LAYERS.LOGO.name).addChild(logo);
        this._logo = logo;

    }

    protected onResize(data:IResizeData):void {
        this._logo.position.set(Helper.getSymbolPositions(1, 0)[0], Helper.getSymbolPositions(1, 0)[1] - StarStruckGameConfig.instance.SYMBOL_HEIGHT / 2);
    }
}